import React from 'react';
import { Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { isNumber } from 'lodash/fp';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { CardContent, Typography } from '../../../../ui-kit';
import { useUser } from '../../../../utils/hooks/auth';
import { generateTranslationByVenueType } from '../../../../utils';
import { ColoredCard } from '../style';
import { TopProduct } from './types';

const TopProductCard = ({ name, quantity, totalPriceSold, foodCost, netMargin }: TopProduct) => {
    const { priceService } = usePriceService();
    const { t } = useTranslation();
    const { user: { defaultCurrency: { currencyCode }, venueType } } = useUser();
    return (
        <ColoredCard fullHeight>
            <CardContent padding={2}>
                <Tooltip title={name} aria-label={name} placement='top'>
                    <div>
                        <Typography variant='h5' gutterBottom noWrap>{name}</Typography>
                    </div>
                </Tooltip>
                <Typography variant='caption' color='textSecondary'>{t('Gross revenue')}</Typography>
                <Typography variant='body2' gutterBottom>{priceService.toLocaleString(totalPriceSold, currencyCode)}</Typography>

                <Typography variant='caption' color='textSecondary'>{t('Quantity sold')}</Typography>
                <Typography variant='body2' gutterBottom>{t('{{count}} item', { count: quantity })}</Typography>

                <Typography variant='caption' color='textSecondary'>{t('Markup')}</Typography>
                <Typography variant='body2' gutterBottom>
                    {isNumber(netMargin)
                        ? priceService.toLocaleString(netMargin, currencyCode)
                        : t('N/A')}
                </Typography>

                <Typography variant='caption' color='textSecondary'>
                    {generateTranslationByVenueType({
                        translations: {
                            Restaurant: t('Food cost'),
                            Ecommerce: t('COGS')
                        },
                        venueType,
                    })}
                </Typography>
                <Typography variant='body2'>
                    {isNumber(foodCost)
                        ? `${priceService.fractionToPercent(foodCost, 2)}%`
                        : t('N/A')}
                </Typography>
            </CardContent>
        </ColoredCard>
    );
};

export default TopProductCard;
